import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Loginimage-woman-smile-happy-joy 1.png';
import BackgroundImage from '../../Assets/images/LoginAndSignUpBG.png';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../config';
const SignUp = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);

  // Initialize state with values from sessionStorage
  const [phoneNumber, setPhoneNumber] = useState(
    () => sessionStorage.getItem('phoneNumber') || ''
  );
  const [password, setPassword] = useState(
    () => sessionStorage.getItem('password') || ''
  );
  const [ReTypepassword, setReTypepassword] = useState(
    () => sessionStorage.getItem('reTypePassword') || ''
  );
  const [selectedRole, setSelectedRole] = useState(
    () => sessionStorage.getItem('selectedRole') || ''
  );

  // Update sessionStorage whenever state changes
  useEffect(() => {
    sessionStorage.setItem('phoneNumber', phoneNumber);
  }, [phoneNumber]);

  useEffect(() => {
    sessionStorage.setItem('password', password);
  }, [password]);

  useEffect(() => {
    sessionStorage.setItem('reTypePassword', ReTypepassword);
  }, [ReTypepassword]);

  useEffect(() => {
    sessionStorage.setItem('selectedRole', selectedRole);
  }, [selectedRole]);

  const handleLoginClick = () => navigate('/login');

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const toggleReTypePasswordVisibility = () =>
    setPasswordReTypeVisible(!passwordReTypeVisible);

  const validateForm = () => {
    const newErrors = {};
    if (!phoneNumber) newErrors.username = 'Mobile number is required';
    if (!password) newErrors.password = 'Password is required';
    if (!ReTypepassword)
      newErrors.ReTypepassword = 'Re-Type Password is required';
    if (!selectedRole) newErrors.role = 'Please select a role';
    return newErrors;
  };

  const handleSignUp = async () => {
    // Validate form and check for errors
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length !== 0) {
      setErrors(validationErrors);
      return;
    }

    // Prepare sign-up data
    const signUpData = {
      user_type: selectedRole.toLowerCase(),
      phone: phoneNumber,
      password,
      confirm_password: ReTypepassword,
    };

    try {
      // Send sign-up request to the server
      const response = await axios.post(
        `${API_BASE_URL}/account/signup/`,
        // 'https://finwise-backend.vercel.app/account/signup/',
        // 'https://finwiseback.finwise.com.bd/account/signup/',
        // 'http://127.0.0.1:8000/account/signup/',
        signUpData,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': 'z91BDRm6OBq66qusVK8HCtvtdW686hFC',
          },
          withCredentials: true,
        }
      );

      console.log(response);

      // Success modal with custom styling
      Swal.fire({
        title: 'Success!',
        text: 'Please verify your OTP.',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });

      navigate('/otp');
    } catch (error) {
      if (error.response) {
        console.error('Sign-up error:', error.response.data);
        if (error.response.status === 400) {
          Swal.fire({
            // icon: 'warning',
            title: 'Invalid phone number!',
            text: 'Use a valid phone number.',
            customClass: {
              popup: 'w-80 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              // text: 'text-xs',
              confirmButton:
                'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
            },
          });
        } else if (error.response.status === 403) {
          Swal.fire({
            // icon: 'warning',
            title: 'User already exist!',
            text: 'Phone number is already exist. Please try another number.',
            customClass: {
              popup: 'w-80 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              // text: 'text-xs',
              confirmButton:
                'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
            },
          });
        } else if (error.response.status === 422) {
          Swal.fire({
            // icon: 'warning',
            title: 'Password do not match!',
            text: 'Password does not matched, please try again.',
            customClass: {
              popup: 'w-80 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              // text: 'text-xs',
              confirmButton:
                'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
            },
          });
        }
      } else {
        Swal.fire({
          // icon: 'error',
          title: 'Error!',
          text: 'Please try after 30 minutes.',
          customClass: {
            popup: 'w-80 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            // text: 'text-xs',
            confirmButton:
              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
          },
        });
      }
    }
  };

  const handleSignUpKey = e => {
    if (e.key === 'Enter') handleSignUp();
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen md:py-0 py-2 md:mt-16 mt-24 "
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <div className="bg-white md:p-2 p-8 lg:pl-10 lg:pr-10 gap-10 shadow-xl rounded-xl">
        {/* top secton */}
        <div className="items-center justify-center flex">
          <img
            src={LoginLogo}
            alt="LoginLogo"
            className="md:h-16 h-10 lg:h-16 mb-0 pr-10 lg:mb-1"
          />
        </div>
        <h2 className="items-center justify-center flex lg:font-bold lg:mb-4 text-xs lg:text-sm">
          Trade and Finance Solutions
        </h2>

        <div className="items-center justify-center flex flex-col lg:flex-row gap-16">
          {/* left section */}
          <div className="lg:block hidden">
            <img
              src={LoginImg}
              alt="LoginImg"
              className="md:h-40 h-32 lg:h-52"
            />
          </div>

          {/* right section */}
          <div>
            <h2 className="text-xl text-center lg:text-2xl font-semibold mt-1 mb-2 heading">
              Registration
            </h2>

            <div className="w-full space-y-4 mt-2 text-xs">
              {/* Radio Buttons */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                <label className="flex items-center space-x-2 border-2 p-2 border-gray-300 rounded-md w-full">
                  <input
                    type="radio"
                    name="role"
                    className="hidden peer"
                    // value="Corporate"
                    // value={selectedRole}
                    value="Corporate" // Set specific value for Corporate
                    checked={selectedRole === 'Corporate'} // Check if selectedRole matches the value
                    onChange={e => setSelectedRole(e.target.value)}
                  />
                  <div className="w-3 h-3 border-2 ring-2 ring-gray-500 border-gray-300 rounded-full peer-checked:bg-gray-500"></div>
                  <span className="p-0.5 ">Corporate</span>
                </label>

                <label className="flex items-center space-x-2 border-2 p-2 border-gray-300 rounded-md w-full">
                  <input
                    type="radio"
                    name="role"
                    className="hidden peer"
                    // value="Bank"
                    // value={selectedRole}
                    value="Bank"
                    checked={selectedRole === 'Bank'}
                    onChange={e => setSelectedRole(e.target.value)}
                  />
                  <div className="w-3 h-3 border-2 ring-2 ring-gray-500 border-gray-300  rounded-full peer-checked:bg-gray-500"></div>
                  <span className="p-0.5 md:block flex md:gap-0 gap-2">
                    Bank
                  </span>
                </label>

                <label className="flex items-center space-x-2 border-2 p-2 border-gray-300 rounded-md w-full">
                  <input
                    type="radio"
                    name="role"
                    className="hidden peer"
                    // value="Individual"
                    // value={selectedRole}
                    value="Individual"
                    checked={selectedRole === 'Individual'}
                    onChange={e => setSelectedRole(e.target.value)}
                  />
                  <div className="w-3 h-3 border-2 ring-2 ring-gray-500 border-gray-300 rounded-full peer-checked:bg-gray-500"></div>
                  <span className="p-0.5 md:block flex md:gap-0 gap-2">
                    Individuals
                  </span>
                </label>
              </div>
              {errors.role && (
                <p className="text-red-500 text-xs text-left mb-0 -mt-2">
                  {errors.role}
                </p>
              )}
              {/* Input Fields */}
              <div className="flex flex-col space-y-4">
                <input
                  type="text"
                  placeholder="+880 Mobile Number "
                  className="border border-gray-300 rounded-md py-2 px-4 w-full"
                  value={phoneNumber}
                  onChange={e => setPhoneNumber(e.target.value)}
                  onKeyDown={handleSignUpKey}
                  onInput={e => {
                    let inputValue = e.target.value;
                    // Allow only one "+" at the beginning and numbers after
                    inputValue = inputValue.replace(/[^0-9+]/g, ''); // Only keep numbers and "+"
                    inputValue = inputValue.replace(/(?!^)\+/g, ''); // Remove "+" if it's not at the beginning
                    e.target.value = inputValue;
                  }}
                  min="0"
                />

                {errors.username && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.username}
                  </p>
                )}

                <div className="relative w-full">
                  <input
                    type={passwordVisible ? 'text' : 'password'}
                    placeholder="Password"
                    className="border border-gray-300 rounded-md py-2 px-4 w-full"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    onKeyDown={handleSignUpKey}
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
                  >
                    {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                    <span className="ml-1 text-sm">
                      {passwordVisible ? 'Hide' : 'Show'}
                    </span>
                  </button>
                </div>
                {errors.password && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.password}
                  </p>
                )}

                <div className="relative w-full">
                  <input
                    type={passwordReTypeVisible ? 'text' : 'password'}
                    placeholder="Re-Type Pass"
                    className="border border-gray-300 rounded-md py-2 px-4 w-full"
                    value={ReTypepassword}
                    onChange={e => setReTypepassword(e.target.value)}
                    onKeyDown={handleSignUpKey}
                  />
                  <button
                    type="button"
                    onClick={toggleReTypePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
                  >
                    {passwordReTypeVisible ? <FaEyeSlash /> : <FaEye />}
                    <span className="ml-1 text-sm">
                      {passwordReTypeVisible ? 'Hide' : 'Show'}
                    </span>
                  </button>
                </div>
                {errors.ReTypepassword && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.ReTypepassword}
                  </p>
                )}
              </div>
              {/* Create Account Button */}
              <button
                onClick={handleSignUp}
                className="w-full bg-orange-300 text-white py-2 px-6 hover:bg-btnHover mb-2 mt-2 rounded-2xl"
              >
                Create an Account
              </button>

              {/* Already have an account? */}
              <p className="mb-0 text-center text-xs text-gray-600">
                Already have an account?
                <button onClick={handleLoginClick} className="underline ml-2">
                  Login
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
